<template>
  <div id="container">
    <user-image :img="imageUser"></user-image>
    <h2 class="animate__animated animate__fadeInDown">Transformadas 3D</h2>
    <menu-vertical
      class="menu"
      :explicacion="pathModulo.explicacion"
      :demostracion="pathModulo.demostracion"
      :actividad="pathModulo.actividad"
      :cuestionario="pathModulo.cuestionario"
    ></menu-vertical>
    <!-- <barra-herramientas /> -->
    <div>
      <h3 class="info1 animate__animated animate__fadeInRight">
        <div
          v-if="estadoActividad != 0"
          style="font-weight: bold; color: #00ff00"
        >
          {{ titulo }}
        </div>
        {{ descripcion }}
        <div v-if="descripcion2 != null">
          {{ descripcion2 }}
        </div>
        <div v-if="estadoActividad < 4 && coordenadasCubo.x != null">
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Coordenada X: " + coordenadasCubo.x
          }}</span>
          <br />
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Coordenada Y: " + coordenadasCubo.y
          }}</span>
          <br />
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Coordenada Z: " + coordenadasCubo.z
          }}</span>
        </div>
        <div
          v-if="
            estadoActividad > 3 &&
            estadoActividad < 7 &&
            coordenadasCubo.x != null
          "
        >
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Escala X: " + coordenadasCubo.x
          }}</span>
          <br />
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Escala Y: " + coordenadasCubo.y
          }}</span>
          <br />
          <span style="font-weight: bold" v-if="coordenadasCubo.x != null">{{
            "Escala Z: " + coordenadasCubo.z
          }}</span>
        </div>
        <div v-if="estadoActividad == 0">
          <button
            @click="iniciarActividad()"
            style="
              background-color: #00ff00;
              color: white;
              margin-top: 2%;
              padding: 2%;
              border-radius: 12px;
            "
          >
            Comenzar
          </button>
        </div>
      </h3>
    </div>
    <div>
      <h3
        class="info2 animate__animated animate__fadeInRight"
        style="color: #00ff00; font-weight: bold"
      >
        Enhorabuena!. Has terminado la actividad demostrativa de
        transformacioness 3D.
      </h3>
    </div>
    <!-- <router-link to="/actividad-sistema-de-coordenadas">Actividad</router-link> -->
    <div v-if="felicidades" class="felicidades">
      <img
        src="@/assets/img/icons3D/bang_perspective_matte.png"
        alt="bang_perspective_matte"
      />
      <h2>¡FELICITACIONES!</h2>
      <p>
        Acabas de obtener otro logro, por finalizar la Actividad de
        <b> Transformaciones 3D</b>.
      </p>
      <router-link class="botonLogro" to="/cuestionario-transformadas-3D"
        >Continuar</router-link
      >
    </div>
    <a v-if="continuar" @click="logro()">Continuar</a>
  </div>
</template>
<script>
import * as Three from "three";
// import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
//import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import MenuVertical from "@/components/MenuVertical.vue";
import { TransformControls } from "three/examples/jsm/controls/TransformControls.js";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import UserImage from "../../components/UserImage.vue";
export default {
  name: "DemostacionSistemaCoordenadas",
  components: {
    MenuVertical,
    UserImage,
  },
  data() {
    return {
      felicidades: false,
      continuar: false,
      cont: 1,
      siguiente: false,
      camera: null,
      scene: null,
      renderer: null,
      anim: null,
      raycaster: null,
      control: null,
      cube: null,
      orbit: null,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
      logros: [],
      pathModulo: {
        explicacion: "/transformadas-3d",
        demostracion: "/demostracion-transformadas-3d",
        actividad: "/actividad-transformadas-3d",
        cuestionario: "/cuestionario-transformadas-3d",
      },
      descripcion: null,
      descripcion2: null,
      descripcion3: null,
      seguimientoCoordenadas: false,
      coordenadasCubo: {
        x: null,
        y: null,
        z: null,
      },
      estadoActividad: null,
      titulo: "Translación",
    };
  },
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        50,
        container.clientWidth / container.clientHeight,
        0.01,
        30000
      );
      this.camera.position.set(1000, 500, 1000);
      this.camera.lookAt(0, 200, 0);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(this.renderer.domElement);

      this.scene = new Three.Scene();
      this.scene.add(new Three.GridHelper(1000, 10, 0x888888, 0x444444));

      const light = new Three.DirectionalLight(0xffffff, 2);
      light.position.set(1, 1, 1);
      this.scene.add(light);

      const geometry = new Three.BoxGeometry(200, 200, 200);
      const material = new Three.MeshLambertMaterial({ color: 0xffffff });

      // this.orbit = new OrbitControls(this.camera, this.renderer.domElement);
      // this.orbit.update();
      // this.orbit.addEventListener("change", this.render);

      // this.control.addEventListener("dragging-changed", function (event) {
      //   this.orbit.enabled = !event.value;
      // });
      this.cube = new Three.Mesh(geometry, material);
      this.scene.add(this.cube);

      this.control = new TransformControls(
        this.camera,
        this.renderer.domElement
      );
      this.control.addEventListener("change", () =>
        this.renderer.render(this.scene, this.camera)
      );

      this.control.attach(this.cube);
      this.scene.add(this.control);
      document.addEventListener("keydown", this.onDocumentKeyDown);
      document.addEventListener("keyup", this.onDocumentKeyUp);
    },
    onDocumentKeyDown(event) {
      switch (event.keyCode) {
        case 87: // W
          this.control.setMode("translate");
          break;

        case 69: // E
          this.control.setMode("rotate");
          break;

        case 82: // R
          this.control.setMode("scale");
          break;

        case 32: // Spacebar
          this.control.enabled = !this.control.enabled;
          break;
        case 81: // Q
          this.control.enabled = !this.control.enabled;
          this.control.showX = false;
          this.control.showY = false;
          this.control.showZ = false;
          break;
      }
    },
    onDocumentKeyUp(event) {
      switch (event.keyCode) {
        case 16: // Shift
          this.control.setTranslationSnap(0, 0, 0);
          this.control.setRotationSnap(null);
          this.control.setScaleSnap(200);
          break;
      }
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      // TWEEN.update();
      requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
      window.addEventListener("resize", this.onWindowResize);
      if (this.seguimientoCoordenadas) {
        this.coordenadasCubo.x = Math.round(this.cube.position.x);
        this.coordenadasCubo.y = Math.round(this.cube.position.y);
        this.coordenadasCubo.z = Math.round(this.cube.position.z);
      }
      if (this.estadoActividad > 3) {
        this.coordenadasCubo.x = Math.round(this.cube.scale.x);
        this.coordenadasCubo.y = Math.round(this.cube.scale.y);
        this.coordenadasCubo.z = Math.round(this.cube.scale.z);
      }
      switch (this.estadoActividad) {
        case 1:
          if (this.cube.position.x < -200) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showX = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.control.attach(this.cube);
              this.control.showY = true;
              this.descripcion = "Seguiremos con la translacion en el eje Y.";
              this.descripcion2 =
                "Debes mover el eje Y del cubo a la coordenada 300 ";
              this.estadoActividad = 2;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 2:
          if (this.cube.position.y > 300) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showY = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.control.attach(this.cube);
              this.control.showZ = true;
              this.descripcion = "Seguiremos con la translacion en el eje Z.";
              this.descripcion2 =
                "Debes mover el eje Z del cubo a la coordenada 200 ";
              this.estadoActividad = 3;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 3:
          if (this.cube.position.z > 200) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showZ = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.coordenadasCubo = {
                x: null,
                y: null,
                z: null,
              };
              this.control.setMode("scale");
              this.titulo = " Escalación";
              this.control.attach(this.cube);
              this.descripcion =
                "Ahora vamos a hacer una desmotración sobre el escalamiento de objetos";
              this.descripcion2 =
                "Debes escalar el objeto en el eje X del cubo a 2";
              this.control.showX = true;
              this.estadoActividad = 4;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 4:
          if (this.cube.scale.x > 2) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showX = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.control.attach(this.cube);
              this.descripcion = "Seguiremos con la translacion en el eje Y.";
              this.descripcion2 =
                "Debes escalar el objeto en el eje Y del cubo a 2 ";
              this.control.showY = true;
              this.estadoActividad = 5;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 5:
          if (this.cube.scale.y > 2) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showY = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.control.attach(this.cube);
              this.descripcion = "Seguiremos con la translacion en el eje Z.";
              this.descripcion2 =
                "Debes escalar el objeto en el eje Z del cubo a 2 ";
              this.control.showZ = true;
              this.estadoActividad = 6;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 6:
          if (this.cube.scale.z > 2) {
            const info = document.querySelector(".info1");
            info.classList.add("animate__fadeOut");
            this.control.enabled = false;
            this.control.showZ = false;
            this.control.detach();
            setTimeout(() => {
              this.control.enabled = true;
              this.control.setMode("rotate");
              this.titulo = "Rotación";
              this.control.attach(this.cube);
              this.descripcion =
                "Ahora vamos a hacer una desmotración sobre la rotación de objetos";
              this.descripcion2 =
                "Podras rotar el objeto en los X,Y y Z, durante 10 segundos.";
              this.control.showX = true;
              this.control.showY = true;
              this.control.showZ = true;
              this.continuar = true;
              this.estadoActividad = 7;
              info.classList.remove("animate__fadeOut");
              info.classList.add("animate__fadeInRight");
            }, 1000);
          }
          break;
        case 7:
          if (this.titulo == "Rotación") {
            setTimeout(() => {
              this.control.enabled = false;
              this.control.detach();
              this.control.showX = false;
              this.control.showY = false;
              this.control.showZ = false;
              const info = document.querySelector(".info1");
              info.classList.add("animate__fadeOut");
              this.estadoActividad = 8;
            }, 5000);
          }
          break;
        case 8:
          setTimeout(() => {
            this.estadoActividad = 9;
            document.querySelector(`.info2`).style.display = "block";
            const info = document.querySelector(".info2");
            info.classList.add("animate__fadeOut");
            info.classList.remove("animate__fadeOut");
            info.classList.add("animate__fadeInRight");
          }, 1000);
          break;
      }
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logro() {
      this.felicidades = true;
      if (this.logros.indexOf("ActividadTransformadas3d") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.logros.push("ActividadTransformadas3d");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)}}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    iniciarVariables() {
      this.descripcion =
        "La siguiente actividad consiste en una practica demostrativa, en la que podremos comprender un poco mas acerca de la translación, escalación y rotación de objetos";
      this.control.showX = false;
      this.control.showY = false;
      this.control.showZ = false;
      this.estadoActividad = 0;
    },
    iniciarActividad() {
      const info = document.querySelector(".info1");
      info.classList.add("animate__fadeOut");
      setTimeout(() => {
        this.descripcion =
          "Iniciaremos con la translación de objetos, con las flechas puedes mover el cubo.";
        this.descripcion2 =
          "Inicialmente vamos a mover el eje X del cubo a la coordenada -200 ";
        this.control.showX = true;
        this.control.showY = false;
        this.control.showZ = false;
        this.seguimientoCoordenadas = true;
        this.estadoActividad = 1;
        this.control.setMode("translate");
        info.classList.remove("animate__fadeOut");
        info.classList.add("animate__fadeInRight");
      }, 1000);
    },
    alertDialog(title, message, type) {
      this.$swal({
        title: title,
        text: message,
        type: type,
        showCancelButton: false,
        confirmButtonText: "Aceptar",
      });
    },
  },
  mounted() {
    this.profile();
    this.init();
    this.animate();
    this.iniciarVariables();
  },
};
</script>
<style scoped>
#container {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
.menu {
  position: absolute;
}
h2 {
  position: absolute;
  margin-top: 1rem;
  margin: auto;
  right: 0;
  left: 0;
  width: fit-content;
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
  font-family: "Exo 2", sans-serif;
}
.info1,
.info2 {
  display: block;
  position: absolute;
  background: #fff;
  width: 30%;
  right: 0;
  top: 5rem;
  padding: 1rem;
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
  text-align: initial;
}
.info2 {
  display: none;
}
a {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  /* right: calc(40%-var(--espacio)); */
  right: 2rem;
  top: 30rem;
  padding: 1rem;
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
.botonLogro {
  position: initial;
  z-index: 10;
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
</style>
